/* Modernizr */
/* ---------------------------------------------------------------------------------------------------- */
window.Modernizr=function(a,b,c){function y(a){i.cssText=a}function z(a,b){return y(prefixes.join(a+";")+(b||""))}function A(a,b){return typeof a===b}function B(a,b){return!!~(""+a).indexOf(b)}function C(a,b){for(var d in a){var e=a[d];if(!B(e,"-")&&i[e]!==c)return b=="pfx"?e:!0}return!1}function D(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:A(f,"function")?f.bind(d||b):f}return!1}function E(a,b,c){var d=a.charAt(0).toUpperCase()+a.slice(1),e=(a+" "+m.join(d+" ")+d).split(" ");return A(b,"string")||A(b,"undefined")?C(e,b):(e=(a+" "+n.join(d+" ")+d).split(" "),D(e,b,c))}var d="2.8.3",e={},f=b.documentElement,g="modernizr",h=b.createElement(g),i=h.style,j,k={}.toString,l="Webkit Moz O ms",m=l.split(" "),n=l.toLowerCase().split(" "),o={svg:"http://www.w3.org/2000/svg"},p={},q={},r={},s=[],t=s.slice,u,v=function(a,c,d,e){var h,i,j,k,l=b.createElement("div"),m=b.body,n=m||b.createElement("body");if(parseInt(d,10))while(d--)j=b.createElement("div"),j.id=e?e[d]:g+(d+1),l.appendChild(j);return h=["&#173;",'<style id="s',g,'">',a,"</style>"].join(""),l.id=g,(m?l:n).innerHTML+=h,n.appendChild(l),m||(n.style.background="",n.style.overflow="hidden",k=f.style.overflow,f.style.overflow="hidden",f.appendChild(n)),i=c(l,a),m?l.parentNode.removeChild(l):(n.parentNode.removeChild(n),f.style.overflow=k),!!i},w={}.hasOwnProperty,x;!A(w,"undefined")&&!A(w.call,"undefined")?x=function(a,b){return w.call(a,b)}:x=function(a,b){return b in a&&A(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=t.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(t.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(t.call(arguments)))};return e}),p.canvas=function(){var a=b.createElement("canvas");return!!a.getContext&&!!a.getContext("2d")},p.backgroundsize=function(){return E("backgroundSize")},p.boxshadow=function(){return E("boxShadow")},p.fontface=function(){var a;return v('@font-face {font-family:"font";src:url("https://")}',function(c,d){var e=b.getElementById("smodernizr"),f=e.sheet||e.styleSheet,g=f?f.cssRules&&f.cssRules[0]?f.cssRules[0].cssText:f.cssText||"":"";a=/src/i.test(g)&&g.indexOf(d.split(" ")[0])===0}),a},p.svg=function(){return!!b.createElementNS&&!!b.createElementNS(o.svg,"svg").createSVGRect};for(var F in p)x(p,F)&&(u=F.toLowerCase(),e[u]=p[F](),s.push((e[u]?"":"no-")+u));return e.addTest=function(a,b){if(typeof a=="object")for(var d in a)x(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,typeof enableClasses!="undefined"&&enableClasses&&(f.className+=" "+(b?"":"no-")+a),e[a]=b}return e},y(""),h=j=null,e._version=d,e._domPrefixes=n,e._cssomPrefixes=m,e.testProp=function(a){return C([a])},e.testAllProps=E,e.testStyles=v,e}(this,this.document);

/* Detect Mobile */
/* ---------------------------------------------------------------------------------------------------- */
(function(a){(jQuery.browser=jQuery.browser||{}).mobile=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))})(navigator.userAgent||navigator.vendor||window.opera);

/* Detect Mobile + Tablet */
/* ---------------------------------------------------------------------------------------------------- */
(function(a){(jQuery.browser=jQuery.browser||{}).tablet=/(android|bb\d+|meego).+mobile|android|ipad|playbook|silk|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))})(navigator.userAgent||navigator.vendor||window.opera);

/* Check Webkit Version */
/* ---------------------------------------------------------------------------------------------------- */
function checkWebKitVersion() {
    var result = /AppleWebKit\/([\d.]+)/.exec(navigator.userAgent);
    if ( result ) {
        return parseFloat( result[1] );
    }
    return null;
}

/* Check Chrome Version */
/* ---------------------------------------------------------------------------------------------------- */
function checkChromeVersion() {
    var result = window.navigator.appVersion.match(/Chrome\/(\d+)\./);
    if ( result ) {
        return parseInt( result[1] , 10 );
    }
    return null;
}

/* Check Internet Explorer Version */
/* ---------------------------------------------------------------------------------------------------- */
function checkInternetExplorer() {
    var msie = navigator.userAgent.toLowerCase().indexOf( 'msie ');
    if ( msie > 0 ) {
        var version = parseInt( navigator.userAgent.substring( msie + 5 , navigator.userAgent.indexOf( "." , msie ) ) );            
        if ( document.documentMode ) { version = document.documentMode; }
        if ( version < 7 ) { version = 7; }
        return version;             
    } else if ( Object.hasOwnProperty.call( window , "ActiveXObject" ) && !window.ActiveXObject ) {
        return 11;
    }
    return false;
}

/* Check Firefox Version */
/* ------------------------------------------------------------------------------------------------ */
function checkFirefoxVersion() {
    if ( !( 'CSS' in window ) || !( 'supports' in window.CSS ) || !window.CSS.supports( '-moz-appearance' , 'meterbar' ) || !window.CSS.supports( 'background-blend-mode' , 'difference,normal' ) ) {
        jQuery( 'html' ).addClass( 'browser-firefox-old' );
    }
}

/* Check Pointer Events */
/* ---------------------------------------------------------------------------------------------------- */
function checkPointerEvents() {
    var element = document.createElement('x');
	element.style.cssText = 'pointer-events:auto';
	return element.style.pointerEvents === 'auto';
}

/* Check File Upload */
/* ---------------------------------------------------------------------------------------------------- */
function checkFileUpload() {
    var capableBrowser, regex, _i, _len, _ref;
    capableBrowser = true;
    if ( window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector ) {
        if ( !( "classList" in document.createElement( "a" ) ) ) {
            capableBrowser = false;
        } else {
            _ref = Dropzone.blacklistedBrowsers;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                regex = _ref[_i];
                if ( regex.test( navigator.userAgent ) ) {
                    capableBrowser = false;
                    continue;
                }
            }
        }
    } else {
        capableBrowser = false;
    }
    return capableBrowser;
}

/* Detect Platform */
/* ---------------------------------------------------------------------------------------------------- */
function detectPlatform() {
    
    /* Remove No JS */
    jQuery( 'html' ).removeClass( 'platform-no-js' ).addClass( 'platform-js' );
    
    /* Mac */
    if ( /macintosh/gi.test( navigator.userAgent ) ) {
        jQuery( 'html' ).addClass( 'platform-mac' );
    }
    
    /* Android */
    if ( /(android|silk)/gi.test( navigator.userAgent ) ) {
        jQuery( 'html' ).addClass( 'platform-android' );
    }
    
    /* Apple iOS */
    if ( /(ipad|iphone|ipod)/gi.test( navigator.userAgent ) ) {
        jQuery( 'html' ).addClass( 'platform-ios' );
    }
    
    /* Desktop */
    if ( !jQuery.browser.mobile && !jQuery.browser.tablet ) {
        jQuery( 'html' ).addClass( 'platform-desktop' );
    }
    
    /* Mobile / Tablet */
    if ( jQuery.browser.mobile || jQuery.browser.tablet ) {
        jQuery( 'html' ).addClass( 'platform-mobile' );    
    }
    
    /* Phone */
    if ( jQuery.browser.mobile ) {
        jQuery( 'html' ).addClass( 'platform-phone' );
    }
    
    /* Both */
    if ( jQuery( 'html' ).hasClass( 'platform-desktop' ) || jQuery( 'html' ).hasClass( 'platform-mobile' ) ) {
        jQuery( 'html' ).addClass( 'platform-both' );
    }
    
    /* Chrome */
    if ( /chrome/gi.test( navigator.userAgent ) && !/edge/gi.test( navigator.userAgent )  ) {
        jQuery( 'html' ).addClass( 'browser-chrome' );
    }
    
    /* Android Stock Browser */
    if ( jQuery( 'html' ).hasClass( 'platform-android' ) && !jQuery( 'html' ).hasClass( 'browser-chrome' ) && checkWebKitVersion() && ( checkWebKitVersion() < 537 ) ) {
        jQuery( 'html' ).addClass( 'browser-android-stock' );
    }
    
    /* Firefox */
    if ( navigator.userAgent.toLowerCase().indexOf( 'firefox' ) > -1 ) {
        jQuery( 'html' ).addClass( 'browser-firefox' );
        checkFirefoxVersion();
    }
    
    /* Internet Exlorer */
    if ( checkInternetExplorer() ) {
        jQuery( 'html' ).addClass( 'browser-ie' + checkInternetExplorer() );
    }
    
    /* SVG Support */
    if ( document.implementation.hasFeature( 'http://www.w3.org/TR/SVG11/feature#BasicStructure' , '1.1' ) ) {
        jQuery( 'html' ).addClass( 'platform-svg' );
    }
    
    /* Check For Background Size */
    if ( Modernizr.backgroundsize ) {
        jQuery( 'html' ).addClass( 'platform-backgroundsize' );
    }
    
    /* Check For SVG Support */
    if ( jQuery( 'html' ).hasClass( 'platform-svg' ) ) {
    
        /* Check For Media Query */
        if ( window.matchMedia ) {
        
            /* Media Query */
            var mediaQuery = window.matchMedia( 'only screen and (-moz-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)' );    
        
            /* Check For Retina Screen */
            if ( ( window.devicePixelRatio > 1 ) || ( mediaQuery && mediaQuery.matches ) ) {
                jQuery( 'html' ).addClass( 'platform-retina' );
            }
        
        }
        
    }
	
	/* Pointer Events */
	if ( checkPointerEvents() ) {
		jQuery( 'html' ).addClass( 'platform-pointer-events' );
	}
	
	/* File Upload */
	if ( checkFileUpload() ) {
        jQuery( 'html' ).addClass( 'platform-file-upload' );
	}
             
    /* Hardware Acceleration */
    if ( checkWebKitVersion() ) {
        
        /* Android Chrome */
        if ( jQuery( 'html' ).hasClass( 'platform-android' ) && jQuery( 'html' ).hasClass( 'browser-chrome' ) && ( checkChromeVersion() > 26 ) ) {
            jQuery( 'html' ).addClass( 'platform-gpu' );
        
        /* Other Webkit Browsers */
        } else if ( !jQuery( 'html' ).hasClass( 'platform-android' ) || !jQuery( 'html' ).hasClass( 'browser-chrome' ) ) {
            jQuery( 'html' ).addClass( 'platform-gpu' );
        }

    }
    
    /* Placeholder */
    if ( document.createElement( 'input' ).placeholder == undefined ) {
        jQuery( 'html' ).addClass( 'platform-no-placeholder' );
    }

}